import Layout from './pages/layout/Layout';
import Chat from './pages/chat/Chat';
import { createBrowserRouter } from 'react-router';

export const router = createBrowserRouter([
  {
    path: '/:tenantId?',
    element: <Layout />,
    children: [
      {
        index: true,
        element: <Chat />,
      },
      {
        path: '*',
        lazy: () => import('./pages/NoPage'),
      },
    ],
  },
]);
